module.exports = __webpack_public_path__ + "static/deals-for-you-dark-d03a51c5a5ed7471d615e90e3c0f6dd3.png";